import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import Header from './Components/Header';
import Footer from './Components/Footer';
import Routers from './Routers';
import NewsTicker from './Components/NewsTicker';
import { useEffect, useState } from 'react';

import expoBtn from './Assets/ads/HHG web round.gif'; // button png
import expoPoster from './Assets/ads/HHGwebFinalgif.gif'; // modal image

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function AppContent() {
  const location = useLocation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [hasClosed, setHasClosed] = useState(false);

  useEffect(() => {
    // Open modal only on homepage and only if not closed before
    if (location.pathname === '/' && !hasClosed) {
      setIsModalOpen(true);
    }
  }, [location.pathname, hasClosed]);

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setHasClosed(true);
  };

  return (
    <>
      <ScrollToTop />
      <div data-elementor-type="wp-page" data-elementor-id="6" className="elementor elementor-6">
        <Header />
        <Routers />
        <NewsTicker />
        <Footer />
      </div>

      {/* Sticky Expo Button */}
      {/* <div className="expo-sticky-btn" onClick={() => setIsModalOpen(true)}>
        <img src={expoBtn} alt="Expo" />
      </div> */}

      {/* Modal */}
      {/* {isModalOpen && (
        <div className="expo-modal">
          <div className="expo-modal-content animate-popup">
            <button className="expo-close-btn" onClick={handleCloseModal}>×</button>
            <img src={expoPoster} alt="Expo Poster" />
          </div>
        </div>
      )} */}

      <style>{`
        .expo-sticky-btn {
          position: fixed;
          bottom: 20px;
          right: 20px;
          z-index: 1000;
          cursor: pointer;
        }
        .expo-sticky-btn img {
          width: 350px;
          height: auto;
          transition: transform 0.2s ease;
        }
        .expo-sticky-btn img:hover {
          transform: scale(1.1);
        }

        .expo-modal {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0,0,0,0.6);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 2000;
          animation: fadeIn 0.3s ease;
        }
        .expo-modal-content {
          position: relative;
          background: #fff;
          padding: 20px;
          border-radius: 12px;
          max-width: 90%;
          max-height: 90%;
          overflow: auto;
        }
        .expo-modal-content img {
          max-width: 100%;
          max-height: 80vh;
          border-radius: 8px;
        }
        .expo-close-btn {
          position: absolute;
          top: 10px;
          right: 15px;
          background: transparent;
          border: none;
          font-size: 28px;
          cursor: pointer;
        }

        /* Animations */
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes popup {
          0% { transform: scale(0.8); opacity: 0; }
          100% { transform: scale(1); opacity: 1; }
        }
        .animate-popup {
          animation: popup 0.3s ease;
        }
      `}</style>
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
